import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  UPDATE_PROFILE,
  GET_PROFILE_DATA_BY_TAB,
  CREATE_SALESMAN,
  DELETE_SALESMAN,
  SET_SALESMAN_AS_DEFAULT,
  REMOVE_TEAM_MEMBER,
  INVITE_TEAM_MEMBER,
  REINVITE_TEAM_MEMBER,
  REMOVE_TEAM_MEMBER_INVITATION,
  UPDATE_PROFILE_VERIFICATION,
} from "./actionTypes.js";

import {
  updateProfileSuccess,
  updateProfileFail,
  getProfileDataByTabSuccess,
  getProfileDataByTabFail,
  createSalesmanSuccess,
  createSalesmanFail,
  deleteSalesmanSuccess,
  deleteSalesmanFail,
  setSalesmanAsDefaultSuccess,
  setSalesmanAsDefaultFail,
  removeTeamMemberSuccess,
  removeTeamMemberFail,
  inviteTeamMemberSuccess,
  inviteTeamMemberFail,
  reinviteTeamMemberSuccess,
  reinviteTeamMemberFail,
  removeTeamMemberInvitationSuccess,
  removeTeamMemberInvitationFail,
  updateProfileVerificationSuccess,
  updateProfileVerificationFail,
} from "./actions.js"

import {
  addTeamMemberApi,
  createSalesmanApi,
  deleteSalesmanApi,
  deleteTeamMemberApi,
  profileApi,
  reinviteTeamMemberApi,
  removeInvitationTeamMemberApi,
  setDefaultSalesmanApi,
  updateProfile,
} from "./profileApi.js"

function* fetchProfileData({ payload }) {
  try {
    const response = yield call(profileApi, payload)
    yield put(getProfileDataByTabSuccess(response))
  } catch (error) {
    yield put(getProfileDataByTabFail(error))
  }
}

function* onUpdateProfile({ payload }) {
  try {
    const response = yield call(updateProfile, payload)
    yield put(updateProfileSuccess(response))
  } catch (error) {
    yield put(updateProfileFail(error))
  }
}

function* onUpdateProfileVerification({ payload }) {
  try {
    const response = yield call(updateProfile, payload)
    yield put(updateProfileVerificationSuccess(response))
  } catch (error) {
    yield put(updateProfileVerificationFail(error))
  }
}

function* addNewSalesman({ payload }) {
  try {
    const response = yield call(createSalesmanApi, payload)
    yield put(createSalesmanSuccess(response))
  } catch (error) {
    yield put(createSalesmanFail(error))
  }
}

function* deleteSalesman({ payload }) {
  try {
    const response = yield call(deleteSalesmanApi, payload)
    yield put(deleteSalesmanSuccess(response))
  } catch (error) {
    yield put(deleteSalesmanFail(error))
  }
}

function* onUpdateDefaultSalesman({ payload }) {
  try {
    const response = yield call(setDefaultSalesmanApi, payload)
    yield put(setSalesmanAsDefaultSuccess(response))
  } catch (error) {
    yield put(setSalesmanAsDefaultFail(error))
  }
}

function* removeTeamMember({ payload }) {
  try {
    const response = yield call(deleteTeamMemberApi, payload)
    yield put(removeTeamMemberSuccess(response))
  } catch (error) {
    yield put(removeTeamMemberFail(error))
  }
}

function* addTeamMember({ payload }) {
  try {
    const response = yield call(addTeamMemberApi, payload)
    yield put(inviteTeamMemberSuccess(response))
  } catch (error) {
    yield put(inviteTeamMemberFail(error))
  }
}

function* onReinviteTeamMember({ payload }) {
  try {
    const response = yield call(reinviteTeamMemberApi, payload)
    yield put(reinviteTeamMemberSuccess(response))
  } catch (error) {
    yield put(reinviteTeamMemberFail(error))
  }
}

function* onRemoveTeamMemberInvitation({ payload }) {
  try {
    const response = yield call(removeInvitationTeamMemberApi, payload)
    yield put(removeTeamMemberInvitationSuccess(response))
  } catch (error) {
    yield put(removeTeamMemberInvitationFail(error))
  }
}

function* ProfileSaga() {
  yield takeEvery(UPDATE_PROFILE, onUpdateProfile);
  yield takeEvery(UPDATE_PROFILE_VERIFICATION, onUpdateProfileVerification);
  yield takeEvery(GET_PROFILE_DATA_BY_TAB, fetchProfileData);
  yield takeEvery(CREATE_SALESMAN, addNewSalesman);
  yield takeEvery(DELETE_SALESMAN, deleteSalesman);
  yield takeEvery(SET_SALESMAN_AS_DEFAULT, onUpdateDefaultSalesman);
  yield takeEvery(REMOVE_TEAM_MEMBER, removeTeamMember);
  yield takeEvery(INVITE_TEAM_MEMBER, addTeamMember);
  yield takeEvery(REINVITE_TEAM_MEMBER, onReinviteTeamMember);
  yield takeEvery(REMOVE_TEAM_MEMBER_INVITATION, onRemoveTeamMemberInvitation);
}

export default ProfileSaga
